import { useSyncExternalStore } from "react";

export interface TriggerStore<T> {
  open: (payload: T) => void;
  close: () => void;
  useTrigger: () => T | null;
}

export function createTriggerStore<T>(): TriggerStore<T> {
  let current: T | null = null;
  const listeners = new Set<() => void>();

  const emit = () => listeners.forEach((l) => l());

  const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  };

  const getSnapshot = () => current;

  const open = (payload: T) => {
    current = payload;
    emit();
  };

  const close = () => {
    if (current === null) return;
    current = null;
    emit();
  };

  const useTrigger = (): T | null =>
    useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

  return { open, close, useTrigger };
}
